webpackJsonp([43],{

/***/ "9+jv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Privacy = function Privacy() {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _reactHelmet.Helmet,
            null,
            _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' })
        ),
        _react2.default.createElement(
            'article',
            { role: 'article', about: '/legal/privacy', 'typeof': 'schema:WebPage' },
            _react2.default.createElement('span', {
                property: 'schema:name',
                content: 'Datenschutz',
                className: 'stolo-hidden'
            }),
            _react2.default.createElement(
                _ContentWrapper2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { property: 'schema:text' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Datenschutzerkl\xE4rung'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '1) Einleitung und Kontaktdaten des Verantwortlichen'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.1'
                        ),
                        '\xA0Wir freuen uns, dass du unsere Website besuchst und bedanken uns f\xFCr dein Interesse. Im Folgenden informieren wir dich \xFCber den Umgang mit deinen personenbezogenen Daten bei der Nutzung unserer Website. Personenbezogene Daten sind hierbei alle Daten, mit denen du pers\xF6nlich identifiziert werden kannst.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.2'
                        ),
                        '\xA0Verantwortlicher f\xFCr die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist Becker & Karsten UG (haftungsbeschr\xE4nkt), Sandhauser Str. 107, 13505 Berlin, Deutschland, Tel.: +49 30 609851960, E-Mail: wir@beckerundkarsten.de. Der f\xFCr die Verarbeitung von personenbezogenen Daten Verantwortliche ist diejenige nat\xFCrliche oder juristische Person, die allein oder gemeinsam mit anderen \xFCber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '2) Datenerfassung beim Besuch unserer Website'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.1'
                        ),
                        '\xA0Bei der blo\xDF informatorischen Nutzung unserer Website, also wenn du dich nicht registrierst oder uns anderweitig Informationen \xFCbermittelst, erheben wir nur solche Daten, die dein Browser an den Seitenserver \xFCbermittelt (sog. \u201EServer-Logfiles\u201C). Wenn du unsere Website aufrufst, erheben wir die folgenden Daten, die f\xFCr uns technisch erforderlich sind, um dir die Website anzuzeigen:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Unsere besuchte Website'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Datum und Uhrzeit zum Zeitpunkt des Zugriffs'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Menge der gesendeten Daten in Byte'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Quelle/Verweis, von welchem du auf die Seite gelangtest'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Verwendeter Browser'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Verwendetes Betriebssystem'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Verwendete IP-Adresse (ggf.: in anonymisierter Form)'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Verarbeitung erfolgt gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der Verbesserung der Stabilit\xE4t und Funktionalit\xE4t unserer Website. Eine Weitergabe oder anderweitige Verwendung der Daten findet nicht statt. Wir behalten uns allerdings vor, die Server-Logfiles nachtr\xE4glich zu \xFCberpr\xFCfen, sollten konkrete Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.2'
                        ),
                        '\xA0Diese Website nutzt aus Sicherheitsgr\xFCnden und zum Schutz der \xDCbertragung personenbezogener Daten und anderer vertraulicher Inhalte (z.B. Bestellungen oder Anfragen an uns) eine SSL-bzw. TLS-Verschl\xFCsselung. Du kannst eine verschl\xFCsselte Verbindung an der Zeichenfolge \u201Ehttps://\u201C und dem Schloss-Symbol in deiner Browserzeile erkennen.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '3) Hosting & Content-Delivery-Network'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.1'
                        ),
                        '\xA0Amazon Web Services'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr das Hosting unserer Website und die Darstellung der Seiteninhalte nutzen wir das System des folgenden Anbieters: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxemburg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Daten k\xF6nnen zudem \xFCbermittelt werden an: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA 98109, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'S\xE4mtliche auf unserer Website erhobenen Daten werden auf den Servern des Anbieters verarbeitet. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.2'
                        ),
                        '\xA0Cloudflare'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr das Hosting unserer Website und die Darstellung der Seiteninhalte nutzen wir das System des folgenden Anbieters: Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'S\xE4mtliche auf unserer Website erhobenen Daten werden auf den Servern des Anbieters verarbeitet. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.3'
                        ),
                        '\xA0Shopify'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr das Hosting unserer Website und die Darstellung der Seiteninhalte nutzen wir das System des folgenden Anbieters: Shopify International Limited, Victoria Buildings, 2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland (\u201EShopify\u201C).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Daten werden zudem \xFCbertragen an: Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Kanada.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'S\xE4mtliche auf unserer Website erhobenen Daten werden auf den Servern des Anbieters verarbeitet. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei einer Daten\xFCbermittlung nach Kanada ist ein angemessenes Datenschutzniveau durch einen Angemessenheitsbeschluss der Europ\xE4ischen Kommission gew\xE4hrleistet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.4'
                        ),
                        '\xA0AWS-CloudFront'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir nutzen ein Content Delivery Network des folgenden Anbieters: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxemburg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Dieser Dienst erm\xF6glicht uns, gro\xDFe Mediendateien wie Grafiken, Seiteninhalte oder Skripte \xFCber ein Netz regional verteilter Server schneller auszuliefern. Die Verarbeitung erfolgt zur Wahrung unseres berechtigten Interesses an der Verbesserung der Stabilit\xE4t und Funktionalit\xE4t unserer Website gem. Art. 6 Abs. 1 lit. f DSGVO.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Daten k\xF6nnen zudem \xFCbermittelt werden an: Amazon Web Services, Inc., 410 Terry Avenue North, Seattle, WA 98109, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.5'
                        ),
                        '\xA0Cloudflare'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir nutzen ein Content Delivery Network des folgenden Anbieters: Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Dieser Dienst erm\xF6glicht uns, gro\xDFe Mediendateien wie Grafiken, Seiteninhalte oder Skripte \xFCber ein Netz regional verteilter Server schneller auszuliefern. Die Verarbeitung erfolgt zur Wahrung unseres berechtigten Interesses an der Verbesserung der Stabilit\xE4t und Funktionalit\xE4t unserer Website gem. Art. 6 Abs. 1 lit. f DSGVO. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.6'
                        ),
                        '\xA0Host Europe'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir nutzen ein Content Delivery Network des folgenden Anbieters: Host Europe GmbH, c/o WeWork, Friesenplatz 4, 50672 K\xF6ln, Deutschland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Dieser Dienst erm\xF6glicht uns, gro\xDFe Mediendateien wie Grafiken, Seiteninhalte oder Skripte \xFCber ein Netz regional verteilter Server schneller auszuliefern. Die Verarbeitung erfolgt zur Wahrung unseres berechtigten Interesses an der Verbesserung der Stabilit\xE4t und Funktionalit\xE4t unserer Website gem. Art. 6 Abs. 1 lit. f DSGVO. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.7'
                        ),
                        '\xA0Shopify'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir nutzen ein Content Delivery Network des folgenden Anbieters: Shopify International Limited, Victoria Buildings, 2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland (\u201EShopify\u201C)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Daten k\xF6nnen zudem \xFCbertragen werden an:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Kanada'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107, USA'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Dieser Dienst erm\xF6glicht uns, gro\xDFe Mediendateien wie Grafiken, Seiteninhalte oder Skripte \xFCber ein Netz regional verteilter Server schneller auszuliefern. Die Verarbeitung erfolgt zur Wahrung unseres berechtigten Interesses an der Verbesserung der Stabilit\xE4t und Funktionalit\xE4t unserer Website gem. Art. 6 Abs. 1 lit. f DSGVO. Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei einer Daten\xFCbermittlung nach Kanada ist ein angemessenes Datenschutzniveau durch einen Angemessenheitsbeschluss der Europ\xE4ischen Kommission gew\xE4hrleistet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Datenempf\xE4nger dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '4) Cookies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung bestimmter Funktionen zu erm\xF6glichen, verwenden wir Cookies, also kleine Textdateien, die auf deinem Endger\xE4t abgelegt werden. Teilweise werden diese Cookies nach Schlie\xDFen des Browsers automatisch wieder gel\xF6scht (sog. \u201ESession-Cookies\u201C), teilweise verbleiben diese Cookies l\xE4nger auf deinem Endger\xE4t und erm\xF6glichen das Speichern von Seiteneinstellungen (sog. \u201Epersistente Cookies\u201C). Im letzteren Fall kannst du die Speicherdauer der \xDCbersicht zu den Cookie-Einstellungen deines Webbrowsers entnehmen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern durch einzelne von uns eingesetzte Cookies auch personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO entweder zur Durchf\xFChrung des Vertrages, gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO im Falle einer erteilten Einwilligung oder gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO zur Wahrung unserer berechtigten Interessen an der bestm\xF6glichen Funktionalit\xE4t der Website sowie einer kundenfreundlichen und effektiven Ausgestaltung des Seitenbesuchs.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Du kannst deinen Browser so einstellen, dass du \xFCber das Setzen von Cookies informiert wirst und einzeln \xFCber deren Annahme entscheiden oder die Annahme von Cookies f\xFCr bestimmte F\xE4lle oder generell ausschlie\xDFen kannst.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bitte beachte, dass bei Nichtannahme von Cookies die Funktionalit\xE4t unserer Website eingeschr\xE4nkt sein kann.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '5) Kontaktaufnahme'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.1'
                        ),
                        '\xA0WhatsApp-Business'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir bieten dir die M\xF6glichkeit, mit uns \xFCber den Nachrichtendienst WhatsApp der WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland, in Kontakt zu treten. Hierf\xFCr verwenden wir die sog. \u201EBusiness-Version\u201C von WhatsApp.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern du uns anl\xE4sslich eines konkreten Gesch\xE4fts (beispielsweise einer get\xE4tigten Bestellung) per WhatsApp kontaktierst, speichern und verwenden wir die von dir bei WhatsApp genutzte Mobilfunknummer sowie \u2013 falls bereitgestellt \u2013 deinen Vor- und Nachnamen gem\xE4\xDF Art. 6 Abs. 1 lit. b. DSGVO zur Bearbeitung und Beantwortung deines Anliegens. Auf Basis derselben Rechtsgrundlage werden wir dich per WhatsApp gegebenenfalls um die Bereitstellung weiterer Daten (Bestellnummer, Kundennummer, Anschrift oder E-Mailadresse) bitten, um deine Anfrage einem bestimmten Vorgang zuordnen zu k\xF6nnen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Nutzt Du unseren WhatsApp-Kontakt f\xFCr allgemeine Anfragen (etwa zum Leistungsspektrum, zu Verf\xFCgbarkeiten oder zu unserem Internetauftritt) speichern und verwenden wir die von dir bei WhatsApp genutzte Mobilfunknummer sowie \u2013 falls bereitgestellt \u2013 deinen Vor- und Nachnamen gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der effizienten und zeitnahen Bereitstellung der gew\xFCnschten Informationen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Deine Daten werden stets nur zur Beantwortung deines Anliegens per WhatsApp verwendet. Eine Weitergabe an Dritte findet nicht statt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bitte beachte, dass WhatsApp Business Zugriff auf das Adressbuch des von uns hierf\xFCr verwendeten mobilen Endger\xE4ts erh\xE4lt und im Adressbuch gespeicherte Telefonnummern automatisch an einen Server des Mutterkonzerns Meta Platforms Inc. in den USA \xFCbertr\xE4gt. F\xFCr den Betrieb unseres WhatsApp-Business-Kontos verwenden wir ein mobiles Endger\xE4t, in dessen Adressbuch ausschlie\xDFlich die WhatsApp-Kontaktdaten solcher Nutzer gespeichert werden, die mit uns per WhatsApp auch in Kontakt getreten sind.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Hierdurch wird sichergestellt, dass jede Person, deren WhatsApp-Kontaktdaten in unserem Adressbuch gespeichert sind, bereits bei erstmaliger Nutzung der App auf seinem Ger\xE4t durch Akzeptanz der WhatsApp-Nutzungsbedingungen in die \xDCbermittlung seiner WhatsApp-Telefonnummer aus den Adressb\xFCchern seiner Chat-Kontakte gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO eingewilligt hat. Eine \xDCbermittlung von Daten solcher Nutzer, die WhatsApp nicht verwenden und/oder uns nicht \xFCber WhatsApp kontaktiert haben, wird insofern ausgeschlossen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und Nutzung der Daten durch WhatsApp sowie deine diesbez\xFCglichen Rechte und Einstellungsm\xF6glichkeiten zum Schutz deiner Privatsph\xE4re entnimmst Du bitte den Datenschutzhinweisen von WhatsApp: ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.whatsapp.com/legal/?eea=1#privacy-policy',
                                target: '_blank' },
                            'https://www.whatsapp.com',
                            _react2.default.createElement('wbr', null),
                            '/legal',
                            _react2.default.createElement('wbr', null),
                            '/?eea=1#privacy-policy'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Im Rahmen der oben genannten Verarbeitungen kann es zu Daten\xFCbertragungen an Server von Meta Platforms Inc. in den USA kommen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.2'
                        ),
                        '\xA0Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder E-Mail) werden \u2013 ausschlie\xDFlich zum Zweck der Bearbeitung und Beantwortung deines Anliegens und nur im daf\xFCr erforderlichen Umfang \u2013 personenbezogene Daten verarbeitet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Rechtsgrundlage f\xFCr die Verarbeitung dieser Daten ist unser berechtigtes Interesse an der Beantwortung deines Anliegens gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO. Zielt deine Kontaktierung auf einen Vertrag ab, so ist zus\xE4tzliche Rechtsgrundlage f\xFCr die Verarbeitung Art. 6 Abs. 1 lit. b DSGVO. Deine Daten werden gel\xF6scht, wenn sich aus den Umst\xE4nden entnehmen l\xE4sst, dass der betroffene Sachverhalt abschlie\xDFend gekl\xE4rt ist und sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '6) Kommentarfunktion'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Im Rahmen der Kommentarfunktion auf dieser Website werden neben deinem Kommentar auch Angaben zum Zeitpunkt der Erstellung des Kommentars und der von dir gew\xE4hlte Kommentatorenname gespeichert und auf dieser Website ver\xF6ffentlicht. Ferner wird deine IP-Adresse mitprotokolliert und gespeichert. Diese Speicherung der IP-Adresse erfolgt aus Sicherheitsgr\xFCnden und f\xFCr den Fall, dass du durch einen abgegebenen Kommentar die Rechte Dritter verletzt oder rechtswidrige Inhalte postest. Deine E-Mailadresse ben\xF6tigen wir, um mit dir in Kontakt zu treten, falls ein Dritter deinen ver\xF6ffentlichten Inhalt als rechtswidrig beanstanden sollte.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Rechtsgrundlagen f\xFCr die Speicherung deiner Daten sind die Art. 6 Abs. 1 lit. b und f DSGVO. Wir behalten uns vor, Kommentare zu l\xF6schen, wenn sie von Dritten als rechtswidrig beanstandet werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Nachfolgekommentare kannst du als Nutzer abonnieren. Du erh\xE4ltst hierzu eine Best\xE4tigungs-E-Mail, damit sichergestellt werden kann, dass du der Inhaber der angegebenen E-Mail-Adresse bist (Double-Opt-In-Verfahren). Die Rechtsgrundlage f\xFCr die Datenverarbeitung im Falle der Abonnierung von Kommentaren ist Art. 6 Abs. 1 lit. a DSGVO. Du kannst laufende Kommentarabonnements jederzeit mit Wirkung f\xFCr die Zukunft abbestellen, n\xE4here Informationen zur Abbestellm\xF6glichkeit entnimm bitte der Best\xE4tigungs-E-Mail.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '7) Datenverarbeitung bei Er\xF6ffnung eines Kundenkontos'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO werden personenbezogene Daten im jeweils erforderlichen Umfang weiterhin erhoben und verarbeitet, wenn du uns diese bei der Er\xF6ffnung eines Kundenkontos mitteilst. Welche Daten f\xFCr die Kontoer\xF6ffnung erforderlich sind, entnimmst du der Eingabemaske des entsprechenden Formulars auf unserer Website.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Eine L\xF6schung deines Kundenkontos ist jederzeit m\xF6glich und kann durch eine Nachricht an die o.g. Adresse des Verantwortlichen erfolgen. Nach L\xF6schung deines Kundenkontos werden deine Daten gel\xF6scht, sofern alle dar\xFCber geschlossenen Vertr\xE4ge vollst\xE4ndig abgewickelt sind, keine gesetzlichen Aufbewahrungsfristen entgegenstehen und unsererseits kein berechtigtes Interesse an der Weiterspeicherung fortbesteht.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '8) Nutzung von Kundendaten zur Direktwerbung'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.1'
                        ),
                        '\xA0Anmeldung zu unserem E-Mail-Newsletter'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wenn du dich zu unserem E-Mail Newsletter anmeldest, \xFCbersenden wir dir regelm\xE4\xDFig Informationen zu unseren Angeboten. Pflichtangabe f\xFCr die \xDCbersendung des Newsletters ist allein deine E-Mailadresse. Die Angabe weiterer Daten ist freiwillig und wird verwendet, um dich pers\xF6nlich ansprechen zu k\xF6nnen. F\xFCr den Newsletter-Versand verwenden wir das sog. Double Opt-in Verfahren, mit dem sichergestellt wird, dass du Newsletter erst erh\xE4ltst, wenn du uns durch Bet\xE4tigung eines an die angegebene Mailadresse versandten Verifizierungslinks ausdr\xFCcklich deine Einwilligung in den Newsletterempfang best\xE4tigt hast.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Mit der Aktivierung des Best\xE4tigungslinks erteilst du uns deine Einwilligung f\xFCr die Nutzung deiner personenbezogenen Daten gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO. Hierbei speichern wir deine vom Internet Service-Provider (ISP) eingetragene IP-Adresse sowie das Datum und die Uhrzeit der Anmeldung, um einen m\xF6glichen Missbrauch deiner E-Mail-Adresse zu einem sp\xE4teren Zeitpunkt nachvollziehen zu k\xF6nnen. Die von uns bei der Anmeldung zum Newsletter erhobenen Daten werden streng zweckgebunden verwendet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Du kannst den Newsletter jederzeit \xFCber den daf\xFCr vorgesehenen Link im Newsletter oder durch entsprechende Nachricht an den eingangs genannten Verantwortlichen abbestellen. Nach erfolgter Abmeldung wird deine E-Mailadresse unverz\xFCglich in unserem Newsletter-Verteiler gel\xF6scht, soweit du nicht ausdr\xFCcklich in eine weitere Nutzung deiner Daten eingewilligt hast oder wir uns eine dar\xFCberhinausgehende Datenverwendung vorbehalten, die gesetzlich erlaubt ist und \xFCber die wir dich in dieser Erkl\xE4rung informieren.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.2'
                        ),
                        '\xA0MailChimp'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Der Versand unserer E-Mail-Newsletter erfolgt \xFCber diesen Anbieter: The Rocket Science Group, LLC d/b/a MailChimp, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308, USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf Basis unseres berechtigten Interesses an einem effektiven und nutzerfreundlichen Newsletter-Marketing geben wir deine bei der Newsletter-Anmeldung bereitgestellten Daten gem. Art. 6 Abs. 1 lit. f DSGVO an diesen Anbieter weiter, damit dieser den Newsletterversand in unserem Auftrag \xFCbernimmt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Vorbehaltlich deiner ausdr\xFCcklichen Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO f\xFChrt der Anbieter dar\xFCber hinaus eine statistische Erfolgsauswertung von Newsletter-Kampagnen mittels Web Beacons bzw. Z\xE4hlpixel in den versendeten E-Mails durch, die \xD6ffnungsraten und spezifische Interaktionen mit den Inhalten des Newsletters messen k\xF6nnen. Dabei werden auch Endger\xE4teinformationen (z.B. Zeitpunkt des Aufrufs, IP-Adresse, Browsertyp und Betriebssystem) erhoben und ausgewertet, aber nicht mit anderen Datenbest\xE4nden zusammengef\xFChrt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Deine Einwilligung zum Newsletter-Tracking kannst du jederzeit mit Wirkung f\xFCr die Zukunft widerrufen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der die Daten unserer Seitenbesucher sch\xFCtzt und eine Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '9) Datenverarbeitung zur Bestellabwicklung'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.1'
                        ),
                        '\xA0\xDCbermittlung von Bilddateien zur Bestellabwicklung per E-Mail'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf unserer Website bieten wir dir die M\xF6glichkeit, durch die \xDCbermittlung von Bilddateien per E-Mail die Personalisierung von Produkten zu beauftragen. Dabei wird das eingereichte Bildmotiv als Vorlage f\xFCr die Personalisierung des gew\xE4hlten Produktes verwendet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '\xDCber die auf der Website mitgeteilte Mailadresse kannst du eine oder mehrere Bilddateien aus dem Speicher des verwendeten Endger\xE4tes an uns \xFCbermitteln. Wir erfassen, speichern und verwenden die so \xFCbermittelten Dateien daraufhin ausschlie\xDFlich zur Anfertigung des personalisierten Produktes im Sinne der jeweiligen Leistungsbeschreibung auf unserer Website. Sofern die \xFCbermittelten Bilddateien zur Anfertigung und Abwicklung der Bestellung an spezielle Dienstleister weitergegeben werden, wirst du hier\xFCber in den folgenden Abs\xE4tzen explizit informiert. Eine dar\xFCberhinausgehende Weitergabe erfolgt nicht. Sofern die \xFCbermittelten Dateien bzw. die digitalen Motive personenbezogene Daten (insbesondere Abbildungen von identifizierbaren Personen) enthalten, erfolgen s\xE4mtliche soeben benannten Verarbeitungsvorg\xE4nge ausschlie\xDFlich zum Zwecke der Abwicklung deiner Online-Bestellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Nach abschlie\xDFender Abwicklung der Bestellung werden die \xFCbermittelten Bilddateien automatisch und vollst\xE4ndig gel\xF6scht.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.2'
                        ),
                        '\xA0\xDCbermittlung von Bilddateien zur Bestellabwicklung per Upload-Funktion'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf unserer Website bieten wir dir die M\xF6glichkeit, durch die \xDCbermittlung von Bilddateien \xFCber eine Upload-Funktion die Personalisierung von Produkten zu beauftragen. Dabei wird das eingereichte Bildmotiv als Vorlage f\xFCr die Personalisierung des gew\xE4hlten Produktes verwendet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '\xDCber das Upload-Formular auf der Website kannst du eine oder mehrere Bilddateien aus dem Speicher deines verwendeten Endger\xE4tes unmittelbar per automatisierter, verschl\xFCsselter Daten\xFCbertragung an uns \xFCbermitteln. Wir erfassen, speichern und verwenden die \xFCbermittelten Dateien daraufhin ausschlie\xDFlich zur Anfertigung des personalisierten Produktes im Sinne der jeweiligen Leistungsbeschreibung auf unserer Website. Sofern die \xFCbermittelten Bilddateien zur Anfertigung und Abwicklung der Bestellung an spezielle Dienstleister weitergegeben werden, wirst du hier\xFCber in den folgenden Abs\xE4tzen explizit informiert. Eine dar\xFCberhinausgehende Weitergabe erfolgt nicht. Sofern die \xFCbermittelten Dateien bzw. die digitalen Motive personenbezogene Daten (insbesondere Abbildungen von identifizierbaren Personen) enthalten, erfolgen s\xE4mtliche soeben benannten Verarbeitungsvorg\xE4nge ausschlie\xDFlich zum Zwecke der Abwicklung deiner Online-Bestellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Nach abschlie\xDFender Abwicklung der Bestellung werden die \xFCbermittelten Bilddateien automatisch und vollst\xE4ndig gel\xF6scht.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.3'
                        ),
                        '\xA0Soweit f\xFCr die Vertragsabwicklung zu Liefer- und Zahlungszwecken erforderlich, werden die von uns erhobenen personenbezogenen Daten gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO an das beauftragte Transportunternehmen und das beauftragte Kreditinstitut weitergegeben.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern wir Dir auf Grundlage eines entsprechenden Vertrages Aktualisierungen f\xFCr Waren mit digitalen Elementen oder f\xFCr digitale Produkte schulden, verarbeiten wir die von Dir bei der Bestellung \xFCbermittelten Kontaktdaten (Name, Anschrift, Mailadresse), um Dich im Rahmen unserer gesetzlichen Informationspflichten gem\xE4\xDF Art. 6 Abs. 1 lit. c DSGVO auf geeignetem Kommunikationsweg (etwa postalisch oder per Mail) \xFCber anstehende Aktualisierungen im gesetzlich vorgesehenen Zeitraum pers\xF6nlich zu informieren. Deine Kontaktdaten werden hierbei streng zweckgebunden f\xFCr Mitteilungen \xFCber von uns geschuldete Aktualisierungen verwendet und zu diesem Zweck durch uns nur insoweit verarbeitet, wie dies f\xFCr die jeweilige Information erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Zur Abwicklung Deiner Bestellung arbeiten wir ferner mit dem / den nachstehenden Dienstleister(n) zusammen, die uns ganz oder teilweise bei der Durchf\xFChrung geschlossener Vertr\xE4ge unterst\xFCtzen. An diese Dienstleister werden nach Ma\xDFgabe der folgenden Informationen gewisse personenbezogene Daten \xFCbermittelt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.4'
                        ),
                        '\xA0Billbee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr die Bestellabwicklung nutzen wir den folgenden Anbieter: Billbee GmbH, Arolser Str. 10, 34477 Twistetal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Name, Anschrift sowie gegebenenfalls weitere personenbezogene Daten werden gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO ausschlie\xDFlich zum Zwecke der Abwicklung deiner Online-Bestellung an den Anbieter weitergegeben. Die Weitergabe deiner Daten erfolgt hierbei nur, soweit dies f\xFCr die Abwicklung der Bestellung tats\xE4chlich erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.5'
                        ),
                        '\xA0Shopify Digital Download'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr die Bestellabwicklung nutzen wir den folgenden Anbieter: Shopify International Limited, Victoria Buildings, 2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Name, Anschrift sowie gegebenenfalls weitere personenbezogene Daten werden gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO ausschlie\xDFlich zum Zwecke der Abwicklung der Online-Bestellung an den Anbieter weitergegeben. Die Weitergabe deiner Daten erfolgt hierbei nur, soweit dies f\xFCr die Abwicklung der Bestellung tats\xE4chlich erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.6'
                        ),
                        '\xA0Weitergabe personenbezogener Daten an Versanddienstleister'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '- Deutsche Post'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Als Transportdienstleister nutzen wir den nachstehenden Anbieter: Deutsche Post AG, Charles-de-Gaulle-Stra\xDFe 20, 53113 Bonn, Deutschland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir geben deine E-Mail-Adresse und/oder Telefonnummer gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO vor der Zustellung der Ware zum Zweck der Abstimmung eines Liefertermins bzw. zur Lieferank\xFCndigung an den Anbieter weiter, sofern du hierf\xFCr im Bestellprozess deine ausdr\xFCckliche Einwilligung erteilt hast. Anderenfalls geben wir zum Zwecke der Zustellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO nur den Namen des Empf\xE4ngers und die Lieferadresse an den Anbieter weiter. Die Weitergabe erfolgt nur, soweit dies f\xFCr die Warenlieferung erforderlich ist. In diesem Fall ist eine vorherige Abstimmung des Liefertermins mit dem Anbieter bzw. die Lieferank\xFCndigung nicht m\xF6glich.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Einwilligung kann jederzeit mit Wirkung f\xFCr die Zukunft gegen\xFCber dem oben bezeichneten Verantwortlichen oder gegen\xFCber dem Anbieter widerrufen werden.',
                        _react2.default.createElement('br', null),
                        '- DHL'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Als Transportdienstleister nutzen wir den nachstehenden Anbieter: DHL Paket GmbH, Str\xE4\xDFchensweg 10, 53113 Bonn, Deutschland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir geben deine E-Mail-Adresse und/oder Telefonnummer gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO vor der Zustellung der Ware zum Zweck der Abstimmung eines Liefertermins bzw. zur Lieferank\xFCndigung an den Anbieter weiter, sofern du hierf\xFCr im Bestellprozess deine ausdr\xFCckliche Einwilligung erteilt hast. Anderenfalls geben wir zum Zwecke der Zustellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO nur den Namen des Empf\xE4ngers und die Lieferadresse an den Anbieter weiter. Die Weitergabe erfolgt nur, soweit dies f\xFCr die Warenlieferung erforderlich ist. In diesem Fall ist eine vorherige Abstimmung des Liefertermins mit dem Anbieter bzw. die Lieferank\xFCndigung nicht m\xF6glich.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Einwilligung kann jederzeit mit Wirkung f\xFCr die Zukunft gegen\xFCber dem oben bezeichneten Verantwortlichen oder gegen\xFCber dem Anbieter widerrufen werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.7'
                        ),
                        '\xA0Verwendung von Paymentdienstleistern (Zahlungsdiensten)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '- Paypal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf dieser Website stehen eine oder mehrere Online-Zahlungsarten des folgenden Anbieters zur Verf\xFCgung: PayPal (Europe) S.a.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei Auswahl einer Zahlungsart des Anbieters, bei der du in Vorleistung gehst, werden an diesen deine im Rahmen des Bestellvorgangs mitgeteilten Zahlungsdaten (darunter Name, Anschrift, Bank- und Zahlkarteninformationen, W\xE4hrung und Transaktionsnummer) sowie Informationen \xFCber den Inhalt deiner Bestellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO weitergegeben. Die Weitergabe deiner Daten erfolgt in diesem Falle ausschlie\xDFlich zum Zweck der Zahlungsabwicklung mit dem Anbieter und nur insoweit, als sie hierf\xFCr erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei Auswahl einer Zahlungsart, bei der wir in Vorleistung gehen, wirst du im Bestellablauf auch aufgefordert, bestimmte pers\xF6nliche Daten (Vor- und Nachname, Stra\xDFe, Hausnummer, Postleitzahl, Ort, Geburtsdatum, E-Mail-Adresse, Telefonnummer, ggf. Daten zu einem alternativen Zahlungsmittel) anzugeben.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Um in solchen F\xE4llen unser berechtigtes Interesse an der Feststellung deiner Zahlungsf\xE4higkeit zu wahren, werden diese Daten von uns gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO zum Zwecke einer Bonit\xE4tspr\xFCfung an den Anbieter weitergeleitet. Der Anbieter pr\xFCft auf Basis der von dir angegebenen pers\xF6nlichen Daten sowie weiterer Daten (wie etwa Warenkorb, Rechnungsbetrag, Bestellhistorie, Zahlungserfahrungen), ob die von dir ausgew\xE4hlte Zahlungsm\xF6glichkeit im Hinblick auf Zahlungs- und/oder Forderungsausfallrisiken gew\xE4hrt werden kann.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Bonit\xE4tsauskunft kann Wahrscheinlichkeitswerte enthalten (sog. Score-Werte). Soweit Score-Werte in das Ergebnis der Bonit\xE4tsauskunft einflie\xDFen, haben sie ihre Grundlage in einem wissenschaftlich anerkannten mathematisch-statistischen Verfahren. In die Berechnung der Score-Werte flie\xDFen unter anderem, aber nicht ausschlie\xDFlich, Anschriftendaten ein.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Du kannst dieser Verarbeitung deiner Daten jederzeit durch eine Nachricht an uns oder gegen\xFCber dem Anbieter widersprechen. Jedoch bleibt der Anbieter ggf. weiterhin berechtigt, deine personenbezogenen Daten zu verarbeiten, sofern dies zur vertragsgem\xE4\xDFen Zahlungsabwicklung erforderlich ist.',
                        _react2.default.createElement('br', null),
                        '- Stripe'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf dieser Website stehen eine oder mehrere Online-Zahlungsarten des folgenden Anbieters zur Verf\xFCgung: Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei Auswahl einer Zahlungsart des Anbieters, bei der du in Vorleistung gehst (etwa Kreditkartenzahlung), werden an diesen deine im Rahmen des Bestellvorgangs mitgeteilten Zahlungsdaten (darunter Name, Anschrift, Bank- und Zahlkarteninformationen, W\xE4hrung und Transaktionsnummer) sowie Informationen \xFCber den Inhalt deiner Bestellung gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO weitergegeben. Die Weitergabe deiner Daten erfolgt in diesem Falle ausschlie\xDFlich zum Zweck der Zahlungsabwicklung mit dem Anbieter und nur insoweit, als sie hierf\xFCr erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei Auswahl einer Zahlungsart, bei der der Anbieter in Vorleistung geht (etwa Rechnungs- oder Ratenkauf bzw. Lastschrift), wirst du im Bestellablauf auch aufgefordert, bestimmte pers\xF6nliche Daten (Vor- und Nachname, Stra\xDFe, Hausnummer, Postleitzahl, Ort, Geburtsdatum, E-Mail-Adresse, Telefonnummer, ggf. Daten zu einem alternativen Zahlungsmittel) anzugeben.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Um unser berechtigtes Interesse an der Feststellung der Zahlungsf\xE4higkeit unserer Kunden zu wahren, werden diese Daten von uns gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO zum Zweck einer Bonit\xE4tspr\xFCfung an den Anbieter weitergeleitet. Der Anbieter pr\xFCft auf Basis der von dir angegebenen pers\xF6nlichen Daten sowie weiterer Daten (wie etwa Warenkorb, Rechnungsbetrag, Bestellhistorie, Zahlungserfahrungen), ob die von dir ausgew\xE4hlte Zahlungsm\xF6glichkeit im Hinblick auf Zahlungs- und/oder Forderungsausfallrisiken gew\xE4hrt werden kann.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Bonit\xE4tsauskunft kann Wahrscheinlichkeitswerte enthalten (sog. Score-Werte). Soweit Score-Werte in das Ergebnis der Bonit\xE4tsauskunft einflie\xDFen, haben sie ihre Grundlage in einem wissenschaftlich anerkannten mathematisch-statistischen Verfahren. In die Berechnung der Score-Werte flie\xDFen unter anderem, aber nicht ausschlie\xDFlich, Anschriftendaten ein.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Du kannst dieser Verarbeitung deiner Daten jederzeit durch eine Nachricht an uns oder gegen\xFCber dem Anbieter widersprechen. Jedoch bleibt der Anbieter ggf. weiterhin berechtigt, deine personenbezogenen Daten zu verarbeiten, sofern dies zur vertragsgem\xE4\xDFen Zahlungsabwicklung erforderlich ist.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.8'
                        ),
                        '\xA0Elektronische Widerrufsfunktion f\xFCr Fernabsatzvertr\xE4ge'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Verbraucher, welche auf dieser Website Vertr\xE4ge schlie\xDFen, bei denen ein gesetzliches Widerrufsrecht besteht, haben die M\xF6glichkeit, den Widerruf \xFCber eine elektronische Widerrufsfunktion im Einklang mit den geltenden Widerrufsbestimmungen zu erkl\xE4ren.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei Nutzung der Widerrufsfunktion sind neben Angaben zur Identifizierung des zu widerrufenden Vertrags auch weitere personenbezogene Informationen wie der Vor- und Nachname sowie die Mailadresse des Verbrauchers bereitzustellen oder zu best\xE4tigen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Erhebung dieser Informationen und deren \xDCbermittlung an uns erfolgt hierbei gem\xE4\xDF Art. 6 Abs. 1 lit. b DSGVO und nur insoweit, wie sie f\xFCr die ordnungsgem\xE4\xDFe Bearbeitung des Widerrufs erforderlich sind. Ebenfalls auf Basis von Art. 6 Abs. 1 lit. b DSGVO werden die bereitgestellten personenbezogenen Daten verwendet, um den Zugang der Widerrufserkl\xE4rung per E-Mail best\xE4tigen. Weitere Rechtsgrundlage f\xFCr die Verarbeitung ist Art. 6 Abs. 1 lit. c DSGVO. Wir sind zur Vorhaltung einer elektronischen Widerrufsfunktion f\xFCr entgeltpflichtige Verbraucherfernabsatzvertr\xE4ge gesetzlich verpflichtet.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '10) Seitenfunktionalit\xE4ten'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.1'
                        ),
                        '\xA0Facebook Connect'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf unserer Website stellen wir eine Single-Sign-On-Funktion des folgenden Anbieters bereit: Meta Platforms Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Neben einer \xDCbermittlung von Daten an den o.g. Anbieterstandort k\xF6nnen Daten auch \xFCbermittelt werden an: Meta Platforms Inc., USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wenn du \xFCber einen Account beim Anbieter verf\xFCgst, kannst du dich mit diesen Accountdaten zur Erstellung eines Benutzerkontos bzw. zur Registrierung auf unserer Website anmelden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Beim Besuch dieser Seite kann \xFCber diese Anmeldefunktion eine direkte Verbindung zwischen deinem Browser und den Servern des Anbieters hergestellt werden, auch wenn du keinen Account beim Anbieter besitzt oder nicht in einen solchen eingeloggt bist. Der Anbieter erh\xE4lt dadurch die Information, dass du unsere Seite besucht hast. Die insofern erhobenen Informationen (ggf. einschlie\xDFlich deiner IP-Adresse) werden von deinem Browser direkt an einen Server des Anbieters \xFCbermittelt und dort gespeichert. Die Informationen werden jedoch nicht dazu verwendet, dich pers\xF6nlich zu identifizieren, und werden nicht an Dritte weitergegeben.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Diese Datenverarbeitungsvorg\xE4nge erfolgen gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an einer nutzerfreundlichen und interaktiven Ausgestaltung unseres Online-Auftritts.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bet\xE4tigst du den Anmeldebutton, um dich mit den Daten deines Accounts beim Anbieter auf unserer Website zu registrieren, \xFCbermittelt der Anbieter ausschlie\xDFlich auf Basis deiner ausdr\xFCcklichen Einwilligung gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO die in deinem Account hinterlegten allgemeinen und \xF6ffentlich zug\xE4nglichen Informationen (Nutzer-ID, Name, Anschrift, Mailadresse, Alter und Geschlecht) an uns.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir speichern und verwenden die vom Anbieter \xFCbermittelten Daten zur Einrichtung eines Benutzerkontos mit den notwendigen Daten (Anrede, Vorname, Nachname, Adressdaten, Land, E-Mail-Adresse, Geburtsdatum), sofern du diese gegen\xFCber dem Anbieter freigegeben hast. Umgekehrt k\xF6nnen auf Basis deiner Einwilligung Daten (z.B. Informationen \xFCber dein Surf- oder Kaufverhalten) von uns auf deinen Account beim Anbieter \xFCbertragen werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die erteilte Einwilligung kann jederzeit mit Wirkung f\xFCr die Zukunft uns gegen\xFCber widerrufen werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.2'
                        ),
                        '\xA0Google Sign-In'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf unserer Website stellen wir eine Single-Sign-On-Funktion des folgenden Anbieters bereit: Google Ireland Limited, Gordon House, 4 Barrow St, Dublin, D04 E5W5, Irland.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Neben einer \xDCbermittlung von Daten an den o.g. Anbieterstandort k\xF6nnen Daten auch \xFCbermittelt werden an: Google LLC, USA.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wenn du \xFCber einen Account beim Anbieter verf\xFCgst, kannst du dich mit diesen Accountdaten zur Erstellung eines Benutzerkontos bzw. zur Registrierung auf unserer Website anmelden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Beim Besuch dieser Seite kann \xFCber diese Anmeldefunktion eine direkte Verbindung zwischen deinem Browser und den Servern des Anbieters hergestellt werden, auch wenn du keinen Account beim Anbieter besitzt oder nicht in einen solchen eingeloggt bist. Der Anbieter erh\xE4lt dadurch die Information, dass du unsere Seite besucht hast. Die insofern erhobenen Informationen (ggf. einschlie\xDFlich deiner IP-Adresse) werden von deinem Browser direkt an einen Server des Anbieters \xFCbermittelt und dort gespeichert. Die Informationen werden jedoch nicht dazu verwendet, dich pers\xF6nlich zu identifizieren, und werden nicht an Dritte weitergegeben.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Diese Datenverarbeitungsvorg\xE4nge erfolgen gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an einer nutzerfreundlichen und interaktiven Ausgestaltung unseres Online-Auftritts.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bet\xE4tigst du den Anmeldebutton, um dich mit den Daten deines Accounts beim Anbieter auf unserer Website zu registrieren, \xFCbermittelt der Anbieter ausschlie\xDFlich auf Basis deiner ausdr\xFCcklichen Einwilligung gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO die in deinem Account hinterlegten allgemeinen und \xF6ffentlich zug\xE4nglichen Informationen (Nutzer-ID, Name, Anschrift, Mailadresse, Alter und Geschlecht) an uns.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir speichern und verwenden die vom Anbieter \xFCbermittelten Daten zur Einrichtung eines Benutzerkontos mit den notwendigen Daten (Anrede, Vorname, Nachname, Adressdaten, Land, E-Mail-Adresse, Geburtsdatum), sofern du diese gegen\xFCber dem Anbieter freigegeben hast. Umgekehrt k\xF6nnen auf Basis deiner Einwilligung Daten (z.B. Informationen \xFCber dein Surf- oder Kaufverhalten) von uns auf deinen Account beim Anbieter \xFCbertragen werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die erteilte Einwilligung kann jederzeit mit Wirkung f\xFCr die Zukunft uns gegen\xFCber widerrufen werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr Daten\xFCbermittlungen in die USA hat sich der Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy Framework) angeschlossen, das auf Basis eines Angemessenheitsbeschlusses der Europ\xE4ischen Kommission die Einhaltung des europ\xE4ischen Datenschutzniveaus sicherstellt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Weitere Hinweise zum Datenschutz von Google findest du hier: ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://business.safety.google/intl/de/privacy/',
                                target: '_blank' },
                            'https://business.safety.google',
                            _react2.default.createElement('wbr', null),
                            '/intl',
                            _react2.default.createElement('wbr', null),
                            '/de',
                            _react2.default.createElement('wbr', null),
                            '/privacy',
                            _react2.default.createElement('wbr', null),
                            '/'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.3'
                        ),
                        '\xA0OpenStreetMap'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Diese Webseite nutzt einen Online-Kartendienst des folgenden Anbieters: OpenStreetMap Foundation, St John\u2019s Innovation Centre, Cowley Road, Cambridge, CB4 0WS, UK'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Der Online-Kartendienst ist ein Tool zur Anzeige interaktiver (Land-)Karten, um geographische Informationen visuell darzustellen. \xDCber die Nutzung dieses Dienstes wird dir unser Standort angezeigt und eine etwaige Geolokalisierung erleichtert.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bereits beim Aufrufen derjenigen Unterseiten, in die die Karte des Anbieters eingebunden ist, werden Informationen \xFCber deine Nutzung unserer Webseite (wie z.B. deine IP-Adresse) an Server des Anbieters \xFCbertragen und dort gespeichert.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Verarbeitung deiner personenbezogenen Daten erfolgt gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der bedarfsgerechten Gestaltung unserer Webseite. Wenn du mit der k\xFCnftigen \xDCbermittlung deiner Daten an den Anbieter nicht einverstanden bist, besteht die M\xF6glichkeit, den Online-Kartendienst des Anbieters vollst\xE4ndig zu deaktivieren, indem du die Anwendung JavaScript in deinem Browser ausschaltest. Der Online-Kartendienst auf dieser Webseite kann dann nicht mehr genutzt werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Soweit rechtlich erforderlich, haben wir zur vorstehend dargestellten Verarbeitung deiner Daten deine Einwilligung gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO eingeholt. Du kannst deine erteilte Einwilligung jederzeit mit Wirkung f\xFCr die Zukunft widerrufen. Um deinen Widerruf auszu\xFCben, befolge bitte die vorstehend geschilderte M\xF6glichkeit zur Vornahme eines Widerspruchs.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei einer Daten\xFCbermittlung an den Anbieterstandort ist ein angemessenes Datenschutzniveau durch einen Angemessenheitsbeschluss der Europ\xE4ischen Kommission gew\xE4hrleistet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.4'
                        ),
                        '\xA0- Friendly Captcha'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Auf dieser Website verwenden wir den CAPTCHA-Dienst des folgenden Anbieters: Friendly Captcha GmbH, Am Anger 3-5, 82237 W\xF6rthsee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Der Dienst pr\xFCft, ob eine Eingabe durch eine nat\xFCrliche Person oder missbr\xE4uchlich durch maschinelle und automatisierte Verarbeitung erfolgt, und blockiert Spam, DDoS-Attacken sowie \xE4hnliche automatisierte Schadzugriffe.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wenn du eine Seite unseres Webauftritts aufrufst, die Captcha-Elemente des Anbieters enth\xE4lt, stellt dein Browser eine direkte Verbindung zu den Servern des Anbieters her, um die Elemente ordnungsgem\xE4\xDF zu laden. Hierbei werden bestimmte Browserinformationen, einschlie\xDFlich deiner IP-Adresse, an den Anbieter \xFCbermittelt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Rechtsgrundlage ist unser berechtigtes Interesse an der Feststellung der individuellen Eigenverantwortung im Internet und der Vermeidung von Missbrauch und Spam gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Im Anschluss an die \xDCbermittlung werden die erhobenen Browser-Informationen automatisch unmittelbar anonymisiert, sodass f\xFCr die Verifizierung des menschlichen Ursprungs einer Seiteninteraktion keinerlei personenbezogene Daten verarbeitet werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag abgeschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '11) Tools und Sonstiges'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.1'
                        ),
                        '\xA0Billbee'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr die Erledigung deiner Buchhaltung nutzen wir den Service der cloudbasierten Buchhaltungssoftware des folgenden Anbieters: Billbee GmbH, Arolser Str. 10, 34477 Twistetal, Deutschland.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Der Anbieter verarbeitet Eingangs- und Ausgangsrechnungen sowie ggf. auch die Bankbewegungen unseres Unternehmens, um Rechnungen automatisch zu erfassen, zu den Transaktionen zu matchen und hieraus in einem teilautomatisierten Prozess die Finanzbuchhaltung zu erstellen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern hierbei auch personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung auf Basis unseres berechtigten Interesses an einer effizienten Organisation und Dokumentation unserer Gesch\xE4ftsvorg\xE4nge.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.2'
                        ),
                        '\xA0BuchhaltungsButler'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'F\xFCr die Erledigung deiner Buchhaltung nutzen wir den Service der cloudbasierten Buchhaltungssoftware des folgenden Anbieters: BuchhaltungsButler GmbH, Ausbau 1, 15910 Unterspreewald, Deutschland'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Der Anbieter verarbeitet Eingangs- und Ausgangsrechnungen sowie ggf. auch die Bankbewegungen unseres Unternehmens, um Rechnungen automatisch zu erfassen, zu den Transaktionen zu matchen und hieraus in einem teilautomatisierten Prozess die Finanzbuchhaltung zu erstellen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern hierbei auch personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung auf Basis unseres berechtigten Interesses an einer effizienten Organisation und Dokumentation unserer Gesch\xE4ftsvorg\xE4nge.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.3'
                        ),
                        '\xA0Cookie-Consent-Tool'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Diese Website nutzt zur Einholung wirksamer Nutzereinwilligungen f\xFCr einwilligungspflichtige Cookies und cookie-basierte Anwendungen ein sog. \u201ECookie-Consent-Tool\u201C. Das \u201ECookie-Consent-Tool\u201C wird dir bei Seitenaufruf in Form einer interaktiven Benutzeroberfl\xE4che angezeigt, auf welcher du per H\xE4kchensetzung Einwilligungen f\xFCr bestimmte Cookies und/oder cookie-basierte Anwendungen erteilen kannst. Hierbei werden durch den Einsatz des Tools alle einwilligungspflichtigen Cookies/Dienste nur dann geladen, wenn du entsprechende Einwilligungen per H\xE4kchensetzung erteilst. So wird sichergestellt, dass nur im Falle einer erteilten Einwilligung derartige Cookies auf deinem jeweiligen Endger\xE4t gesetzt werden.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Das Tool setzt technisch notwendige Cookies, um deine Cookie-Pr\xE4ferenzen zu speichern. Personenbezogene Nutzerdaten werden hierbei grunds\xE4tzlich nicht verarbeitet.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Kommt es im Einzelfall zum Zwecke der Speicherung, Zuordnung oder Protokollierung von Cookie-Einstellungen doch zur Verarbeitung personenbezogener Daten (wie etwa der IP-Adresse), erfolgt diese gem\xE4\xDF Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an einem rechtskonformen, nutzerspezifischen und nutzerfreundlichen Einwilligungsmanagement f\xFCr Cookies und mithin an einer rechtskonformen Ausgestaltung unseres Internetauftritts.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Weitere Rechtsgrundlage f\xFCr die Verarbeitung ist ferner Art. 6 Abs. 1 lit. c DSGVO. Wir unterliegen als Verantwortliche der rechtlichen Verpflichtung, den Einsatz technisch nicht notwendiger Cookies von der jeweiligen Nutzereinwilligung abh\xE4ngig zu machen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Soweit erforderlich, haben wir mit dem Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der den Schutz der Daten unserer Seitenbesucher sicherstellt und eine unberechtigte Weitergabe an Dritte untersagt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Weitere Informationen zum Betreiber und den Einstellungsm\xF6glichkeiten des Cookie-Consent-Tools findest du direkt in der entsprechenden Benutzeroberfl\xE4che auf unserer Website.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '12) Rechte des Betroffenen'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.1'
                        ),
                        '\xA0Das geltende Datenschutzrecht gew\xE4hrt dir gegen\xFCber uns als Verantwortlichen hinsichtlich der Verarbeitung deiner personenbezogenen Daten die nachstehenden Betroffenenrechte (Auskunfts- und Interventionsrechte), wobei f\xFCr die jeweiligen Aus\xFCbungsvoraussetzungen auf die angef\xFChrte Rechtsgrundlage verwiesen wird:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Auskunftsrecht gem\xE4\xDF Art. 15 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Berichtigung gem\xE4\xDF Art. 16 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf L\xF6schung gem\xE4\xDF Art. 17 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Einschr\xE4nkung der Verarbeitung gem\xE4\xDF Art. 18 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Unterrichtung gem\xE4\xDF Art. 19 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Daten\xFCbertragbarkeit gem\xE4\xDF Art. 20 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Widerruf erteilter Einwilligungen gem\xE4\xDF Art. 7 Abs. 3 DSGVO;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Recht auf Beschwerde gem\xE4\xDF Art. 77 DSGVO.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.2'
                        ),
                        '\xA0WIDERSPRUCHSRECHT'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'WENN WIR IM RAHMEN EINER INTERESSENABW\xC4GUNG DEINE PERSONENBEZOGENEN DATEN AUFGRUND UNSERES \xDCBERWIEGENDEN BERECHTIGTEN INTERESSES VERARBEITEN, HAST DU DAS JEDERZEITIGE RECHT, AUS GR\xDCNDEN, DIE SICH AUS DEINER BESONDEREN SITUATION ERGEBEN, GEGEN DIESE VERARBEITUNG WIDERSPRUCH MIT WIRKUNG F\xDCR DIE ZUKUNFT EINZULEGEN.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'MACHST DU VON DEINEM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE VERARBEITUNG DER BETROFFENEN DATEN. EINE WEITERVERARBEITUNG BLEIBT ABER VORBEHALTEN, WENN WIR ZWINGENDE SCHUTZW\xDCRDIGE GR\xDCNDE F\xDCR DIE VERARBEITUNG NACHWEISEN K\xD6NNEN, DIE DEINE INTERESSEN, GRUNDRECHTE UND GRUNDFREIHEITEN \xDCBERWIEGEN, ODER WENN DIE VERARBEITUNG DER GELTENDMACHUNG, AUS\xDCBUNG ODER VERTEIDIGUNG VON RECHTSANSPR\xDCCHEN DIENT.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'WERDEN DEINE PERSONENBEZOGENEN DATEN VON UNS VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, HAST DU DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG DIR BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN. DU KANNST DEN WIDERSPRUCH WIE OBEN BESCHRIEBEN AUS\xDCBEN.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'MACHST DU VON DEINEM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR DIE VERARBEITUNG DER BETROFFENEN DATEN ZU DIREKTWERBEZWECKEN.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '13) Dauer der Speicherung personenbezogener Daten'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Die Dauer der Speicherung von personenbezogenen Daten bemisst sich anhand der jeweiligen Rechtsgrundlage, am Verarbeitungszweck und \u2013 sofern einschl\xE4gig \u2013 zus\xE4tzlich anhand der jeweiligen gesetzlichen Aufbewahrungsfrist (z.B. handels- und steuerrechtliche Aufbewahrungsfristen).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei der Verarbeitung von personenbezogenen Daten auf Grundlage einer ausdr\xFCcklichen Einwilligung gem\xE4\xDF Art. 6 Abs. 1 lit. a DSGVO werden die betroffenen Daten so lange gespeichert, bis du deine Einwilligung widerrufst.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Existieren gesetzliche Aufbewahrungsfristen f\xFCr Daten, die im Rahmen rechtsgesch\xE4ftlicher bzw. rechtsgesch\xE4fts\xE4hnlicher Verpflichtungen auf der Grundlage von Art. 6 Abs. 1 lit. b DSGVO verarbeitet werden, werden diese Daten nach Ablauf der Aufbewahrungsfristen routinem\xE4\xDFig gel\xF6scht, sofern sie nicht mehr zur Vertragserf\xFCllung oder Vertragsanbahnung erforderlich sind und/oder unsererseits kein berechtigtes Interesse an der Weiterspeicherung fortbesteht.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei der Verarbeitung von personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO werden diese Daten so lange gespeichert, bis du dein Widerspruchsrecht nach Art. 21 Abs. 1 DSGVO aus\xFCbst, es sei denn, wir k\xF6nnen zwingende schutzw\xFCrdige Gr\xFCnde f\xFCr die Verarbeitung nachweisen, die deine Interessen, Rechte und Freiheiten \xFCberwiegen, oder die Verarbeitung dient der Geltendmachung, Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Bei der Verarbeitung von personenbezogenen Daten zum Zwecke der Direktwerbung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO werden diese Daten so lange gespeichert, bis du dein Widerspruchsrecht nach Art. 21 Abs. 2 DSGVO aus\xFCbst.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sofern sich aus den sonstigen Informationen dieser Erkl\xE4rung \xFCber spezifische Verarbeitungssituationen nichts anderes ergibt, werden gespeicherte personenbezogene Daten im \xDCbrigen dann gel\xF6scht, wenn sie f\xFCr die Zwecke, f\xFCr die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig sind.'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { style: { marginTop: '3rem' } },
                    _react2.default.createElement(
                        'div',
                        { style: {
                                display: 'inline-block',
                                verticalAlign: 'top'
                            } },
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.it-recht-kanzlei.de/', target: '_blank' },
                            _react2.default.createElement('img', {
                                src: 'https://www.it-recht-kanzlei.de/logo/Copyright-Logo_Datenschutzerklaerung.png?i=334dc-19c5e-39c8-907e-1',
                                id: 'itkanzlei_img_copyright', alt: '\xA9 IT-Recht Kanzlei',
                                title: '\xA9 IT-Recht Kanzlei',
                                style: {
                                    marginTop: '-20px',
                                    borderStyle: 'none',
                                    maxWidth: '100%'
                                } })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            style: {
                                display: 'inline-block',
                                verticalAlign: 'top',
                                marginLeft: '5px',
                                float: 'right',
                                whiteSpace: 'nowrap'
                            } },
                        'Stand: 18.06.2026, 12:13:03'
                    ),
                    _react2.default.createElement('div', { style: { clear: 'right' } })
                )
            )
        )
    );
};
exports.default = Privacy;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "V+fu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Privacy = __webpack_require__("9+jv");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Privacy).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/dePrivacy.40ea2a768aa046c09c7b.js